<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            {{
              roleid == 6
                ? "ຈັດການລາຍການ Pre-Order ສິນຄ້າ"
                : "ຈັດການລາຍການ Pre-Order ສິນຄ້າ"
            }}
          </h2>
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 6">
        <b-tab-item label="ຕະຫຼາດ Pre-Order">
          <div class="columns scrollme">
            <div class="column">
              <b-field label="ລາຍການຕະຫຼາດ">
                <table class="table is-fullwidth is-narrow is-small">
                  <thead>
                    <tr>
                      <th class="has-text-centered " width="5%">#</th>
                      <th class="has-text-left " width="15%">
                        ຊື່ຕະຫຼາດ
                      </th>
                      <th class="has-text-left " width="15%">
                        ແຂວງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ເມືອງ
                      </th>
                      <th class="has-text-left " width="15%">
                        ບ້ານ
                      </th>
                      <th class="has-text-left " width="30%">
                        ຈັດການ
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in activemarkets" :key="data.ID">
                      <td class="has-text-centered">{{ index + 1 }}</td>
                      <td>
                        {{ data.MARTKETNAME }}
                      </td>
                      <td>
                        {{ data.PROVINCENAME }}
                      </td>
                      <td>
                        {{ data.DISTRICT }}
                      </td>
                      <td>
                        {{ data.VILLAGE }}
                      </td>

                      <td class="has-text-centered">
                        <b-field group>
                          <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-primary"
                              size="is-small"
                              @click="
                                gotomarketquotadetailform(
                                  data.ID,
                                  data.MARTKETNAME,
                                  data.SELLERID
                                )
                              "
                              >ຟອມວັນທີ Pre-Order
                            </b-button>
                          </b-field>
                          <!-- <b-field>
                            <b-button
                              class="btn-group-margin"
                              type="is-info"
                              size="is-small"
                              @click="
                                gotoquotaToProduction(data.ID, data.MARTKETNAME)
                              "
                              >ໂຄຕ້າທີ່ສົ່ງຜະລິດ
                            </b-button>
                          </b-field> -->
                        </b-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-field>
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="ຟອມ Pre-Order">
          <b-field v-if="marketname === null">
            <button class="button is-info" @click="gotomarketlist">
              ເລືອກຕະຫຼາດ
            </button>
          </b-field>
          <b-field v-else>
            <div class="container">
              <div class="columns">
                <div class="column">
                  <h3 class="title">{{ marketname }}</h3>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <b-tabs v-model="activeFormTab">
                    <b-tab-item label="ຟອມວັນທີ">
                      <div class="container">
                        <div class="columns">
                          <div class="column">
                            <h3 class="subtitle-bold">ຟອມວັນທີ</h3>
                          </div>
                        </div>
                      </div>

                      <div class="container">
                        <div class="columns">
                          <div class="column">
                            <b-field class="group">
                              <b-field
                                label="ວັນທີ ເລີ່ມຮັບອໍເດີ້"
                                style="margin-right: 15px;"
                              >
                              </b-field>
                              <b-field>
                                <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="preorder_startdate"
                                  >" >
                                </b-datepicker>
                              </b-field>
                            </b-field>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            <b-field class="group">
                              <b-field
                                label="ວັນທີ ສິ້ນສຸດຮັບອໍເດີ້"
                                style="margin-right: 15px;"
                              >
                              </b-field>
                              <b-field>
                                <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="preorder_enddate"
                                >
                                </b-datepicker>
                              </b-field>
                            </b-field>
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            <b-field class="group">
                              <b-field
                                label="ວັນທີ ສົ່ງສິນຄ້າ"
                                style="margin-right: 15px;"
                              >
                              </b-field>
                              <b-field>
                                <b-datepicker
                                  :date-formatter="dateFormatter"
                                  v-model="preorder_senddate"
                                >
                                </b-datepicker>
                              </b-field>
                            </b-field>
                          </div>
                        </div>

                        <div class="columns">
                          <div class="column">
                            <b-field class="group">
                              <b-field style="margin-right: 30px;">
                                <b-button
                                  class="btn-group-margin"
                                  type="is-primary"
                                  @click="savePreorderDate()"
                                  >ບັນທືກ
                                </b-button>
                              </b-field>
                            </b-field>
                          </div>
                        </div>
                      </div>
                    </b-tab-item>
                    <b-tab-item label="ລາຍການວັນທີ">
                      <table class="table is-fullwidth is-narrow is-small">
                        <thead>
                          <tr>
                            <th class="has-text-centered " width="5%">#</th>
                            <th class="has-text-left " width="15%">
                              ວັນທີເລີ່ມຮັບອໍເດີ້
                            </th>
                            <th class="has-text-right" width="15%">
                              ວັນທີສິ້ນສຸດຮັບອໍເດີ້
                            </th>
                            <th class="has-text-right" width="15%">
                              ວັນທີສົ່ງ
                            </th>
                            <th class="has-text-right" width="30%">
                              ຈັດການ
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(data, index) in preorderdatelist"
                            :key="data.ID"
                          >
                            <td class="has-text-centered">
                              {{ index + 1 }}/ {{ data.ID }}
                            </td>
                            <td>
                              {{ dateFormatter(data.STARTDATE) }}
                            </td>
                            <td class="has-text-right">
                              {{ dateFormatter(data.ENDDATE) }}
                            </td>
                            <td class="has-text-right">
                              {{ dateFormatter(data.SENDDATE) }}
                            </td>
                            <td class="has-text-right">
                              <span v-if="data.STATUS == 2">ດຳເນີນການແລ້ວ</span>
                              <b-button
                                v-if="data.STATUS == 1"
                                class="btn-group-margin"
                                type="is-primary"
                                size="is-small"
                                @click="
                                  saveProducttoDateForm(
                                    data.ID,
                                    data.STARTDATE,
                                    data.ENDDATE,
                                    data.SENDDATE,
                                    data.STATUS,
                                    data.SELLERID
                                  )
                                "
                                >ປ້ອນສິນຄ້າ
                              </b-button>
                              <b-button
                                class="btn-group-margin"
                                type="is-info"
                                size="is-small"
                                @click="
                                  productsdatedetail(
                                    data.ID,
                                    data.STARTDATE,
                                    data.ENDDATE,
                                    data.SENDDATE,
                                    data.STATUS,
                                    data.SELLERID
                                  )
                                "
                                >ລາຍການສິນຄ້າ
                              </b-button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </b-tab-item>
                    <b-tab-item label="ຟອມປ້ອນສິນຄ້າ">
                      <div class="container">
                        <div class="columns">
                          <div class="column">
                            <h3 class="subtitle-bold">ຟອມປ້ອນສິນຄ້າ</h3>
                          </div>
                          <div class="column">
                            <b-button
                              class="btn-group-margin"
                              type="is-info"
                              size="is-small"
                              @click="
                                productsdatedetail(
                                  selectedpreorderdateid,
                                  selectedstartdate,
                                  selectedenddate,
                                  selectedsenddate,
                                  selectedpreorderdatestatus,
                                  sellectedsellerid
                                )
                              "
                              >ລາຍການສິນຄ້າ
                            </b-button>
                          </div>
                        </div>
                      </div>

                      <div class="container">
                        <div class="columns">
                          <div class="column">
                            <table width="20%" class="table borderless">
                              <tr>
                                <td>
                                  ວັນທີ ເລີ່ມຮັບອໍເດີ້:
                                </td>
                                <td>
                                  {{ dateFormatter(selectedstartdate) }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  ວັນທີ ສິ້ນສຸດຮັບອໍເດີ້:
                                </td>
                                <td>
                                  {{ dateFormatter(selectedenddate) }}
                                </td>
                              </tr>
                              <tr>
                                <td>
                                  ວັນທີ ສົ່ງສິນຄ້າ:
                                </td>
                                <td>
                                  {{ dateFormatter(selectedsenddate) }}
                                </td>
                              </tr>
                            </table>
                          </div>
                        </div>
                        <div>
                          <b-field style="margin-left: 20px">
                            <b-field
                              label="ຄົ້ນຫາສິນຄ້າ"
                              style="margin-right: 15px;"
                            >
                            </b-field>
                            <b-field>
                              <input
                                type="text"
                                class="input"
                                v-model="search"
                              />
                            </b-field>
                          </b-field>
                        </div>
                        <b-tabs v-model="activeSubTab">
                          <b-tab-item
                            :label="type.TYPENAME"
                            v-for="type in productType"
                            :key="type.TYPEID"
                          >
                            <div class="columns">
                              <div class="column has-text-left">
                                ສິນຄ້າ
                              </div>
                              <div class="column">
                                ຈຳນວນ
                              </div>
                              <div class="column">
                                ລາຄາ(ກີບ)
                              </div>
                              <div class="column"></div>
                            </div>

                            <div :label="type.TYPENAME">
                              <b-field
                                v-for="(product, index) in filteredResources"
                                :key="product.PRODUCT_SUB_ID"
                              >
                                <div
                                  class="columns"
                                  v-if="type.TYPEID === product.TYPEID"
                                >
                                  <div class="column has-text-left">
                                    {{ product.PRODUCTNAME }} ({{
                                      product.PRODUCTNAME_SUB
                                    }})<br />
                                    <img
                                      data-v-xcxcc
                                      :src="getImgUrl(product.IMAGEURL)"
                                      width="50"
                                      height="50"
                                    />
                                  </div>
                                  <div class="column">
                                    <b-field v-if="product.MRAMOUNT === null">
                                      <b-input v-model.trim="product.AMOUNT">
                                      </b-input>
                                    </b-field>
                                    <b-field v-else>
                                      <!-- <b-input
                                        v-model.trim="product.MRAMOUNT"
                                        disabled="disabled"
                                      >
                                      </b-input> -->
                                      {{ product.MRAMOUNT | formatNumberLocal }}
                                    </b-field>
                                  </div>
                                  <div class="column">
                                    <b-field v-if="product.MRPRICE === null">
                                      <b-field grouped>
                                        <b-field>
                                          <b-input
                                            v-model.trim="product.PRICE"
                                            type="text"
                                            @input="
                                              numberFormat(index, product.PRICE)
                                            "
                                            maxlength="10"
                                          >
                                          </b-input>
                                        </b-field>
                                        <b-field>
                                          <b-button
                                            class="btn-group-margin"
                                            type="is-primary"
                                            @click="saveProductAmount()"
                                            >ບັນທືກ
                                          </b-button>
                                        </b-field>
                                      </b-field>
                                    </b-field>

                                    <b-field v-else>
                                      <!-- <b-input
                                          v-model.trim="product.MRPRICE"
                                          disabled="disabled"
                                        >
                                        </b-input> -->
                                      {{ product.MRPRICE | formatNumberLocal }}
                                    </b-field>
                                  </div>

                                  <div class="column"></div>
                                </div>
                              </b-field>
                            </div>

                            <div class="columns">
                              <div class="column"></div>
                              <div class="column"></div>

                              <div class="column has-text-right">
                                <b-field group>
                                  <b-field>
                                    <b-button
                                      class="btn-group-margin"
                                      type="is-primary"
                                      @click="saveProductAmount()"
                                      >ບັນທືກ
                                    </b-button>
                                  </b-field>
                                </b-field>
                              </div>

                              <div class="column"></div>
                              <div class="column"></div>
                            </div>
                          </b-tab-item>
                        </b-tabs>
                      </div>
                    </b-tab-item>
                    <b-tab-item label="ລາຍການສິນຄ້າ PreOrder">
                      <b-tabs v-model="activeSubSubTab">
                        <b-tab-item label="ລາຍການສິນຄ້າ PreOrder">
                          <div class="container">
                            <div class="columns">
                              <div class="column">
                                <h3 class="subtitle-bold">
                                  ລາຍການສິນຄ້າ PreOrder
                                </h3>
                              </div>
                              <div class="column">
                                <!-- todate > selectedenddate &&
                                      todate <= selectedsenddate &&
                                      selectedpreorderdatestatus == 1 -->

                                <!-- {{ selectedsenddate }} - {{ selectedpreorderdatestatus }} -->
                                <!-- <b-button
                                  v-if="
                                    selectedpreorderdatestatus == 1 &&
                                      isOrderPrepare == false
                                  "
                                  class="btn-group-margin"
                                  type="is-danger"
                                  size="is-small"
                                  @click="PrepareToOrder()"
                                  >ກວດສອບກ່ອນ Process Order
                                </b-button>

                                <b-button
                                  v-if="
                                    todate <= selectedsenddate &&
                                      selectedpreorderdatestatus == 1 &&
                                      isOrderPrepare == true
                                  "
                                  class="btn-group-margin"
                                  type="is-info"
                                  size="is-small"
                                  @click="processPreorderToOrder()"
                                  >Process Preorder To Order
                                  {{ isOrderPrepare }}
                                </b-button>

                                <b-button
                                  v-if="
                                    todate > selectedsenddate ||
                                      selectedpreorderdatestatus == 2
                                  "
                                  class="btn-group-margin"
                                  type="is-warning"
                                  size="is-small"
                                  >ກາຍມື້ຈັດສົ່ງ ຫຼື ດຳເນີນການແລ້ວ
                                </b-button> -->

                                <!-- <b-button
                                  class="btn-group-margin"
                                  type="is-info"
                                  size="is-small"
                                  @click="OrderDetail()"
                                  >ລາຍລະອຽດການສັ່ງ {{ selectedpreorderdateid }}
                                </b-button> -->

                                <button
                                  class="button is-info is-small"
                                  @click="preordercustomerdetail()"
                                >
                                  ແຍກຕາມລູກຄ້າ
                                </button>
                                &nbsp;
                                <button
                                  class="button is-info is-small"
                                  @click="preorderproductalldetail()"
                                >
                                  ແຍກຕາມສິນຄ້າ
                                </button>
                                &nbsp;
                                <button
                                  v-if="productsdatelist.length > 0"
                                  class="button is-success is-small"
                                  @click="productforbuy()"
                                >
                                  ສັງລວມເພື່ອຈັດຊື້
                                </button>
                                &nbsp;
                                <button
                                  v-if="productsdatelist.length > 0"
                                  class="button is-warning is-small"
                                  @click="custtomernotgetanyproduct()"
                                >
                                  ລູກຄ້າທີ່ບໍ່ໄດ້ສິນຄ້າຈັກລາຍການ
                                </button>
                              </div>
                            </div>
                            <div class="columns">
                              <div class="column">
                                <table width="20%" class="table borderless">
                                  <tr>
                                    <td>
                                      ວັນທີ ເລີ່ມຮັບອໍເດີ້:
                                    </td>
                                    <td>
                                      {{ dateFormatter(selectedstartdate) }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      ວັນທີ ສິ້ນສຸດຮັບອໍເດີ້:
                                    </td>
                                    <td>
                                      {{ dateFormatter(selectedenddate) }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      ວັນທີ ສົ່ງສິນຄ້າ:
                                    </td>
                                    <td>
                                      {{ dateFormatter(selectedsenddate) }}
                                    </td>
                                  </tr>
                                </table>

                                
                              </div>
                            </div>
                            <div class="columns">
                              <div class="column">
                                <table width="100%" class="table ">
                                  <thead>
                                    <tr>
                                      <th class="has-text-centered " width="5%">
                                        #
                                      </th>
                                      <th class="has-text-left " width="30%">
                                        ສິນຄ້າ
                                      </th>
                                      <th class="has-text-right" width="20%">
                                        ຈຳນວນ
                                      </th>
                                      <th class="has-text-right" width="10%">
                                        ລາຄາ
                                      </th>

                                      <th class="has-text-right" width="10%">
                                        ຈັດການ
                                      </th>
                                    </tr>
                                  </thead>
                                  <!-- <tbody>
                                    <tr
                                      v-for="(data, index) in productsdatelist"
                                      :key="data.PREORDERPRODUCTID"
                                    >
                                      <td class="has-text-centered">
                                        {{ index + 1 }}
                                      </td>
                                      <td>
                                        {{ data.PRODUCTNAME }} {{ data.PRODUCTNAME_SUB }} 
                                        <div>
                                          <img data-v-xcxcc :src="getImgUrl(data.IMAGEURL)"  width="100" height="100"/>
                                        </div>
                                      </td>
                                      <td class="has-text-right">
                                        {{ data.QUANTITY | formatNumberLocal}}
                                      </td>
                                      <td class="has-text-right">
                                        {{ data.UNITPRICE  | formatNumberLocal}}
                                      </td>
                                      
                                      <td class="has-text-right">
                                        <b-button v-if="selectedpreorderdatestatus==1"
                                          class="btn-group-margin"
                                          type="is-primary"
                                          size="is-small"
                                          @click="
                                            updatePreOrderProductForm(data)
                                          "
                                          >ແກ້ໄຂ 
                                          </b-button>
                                      </td>
                                    </tr>
                                  </tbody> -->

                                  <tbody>
                                    <tr
                                      v-for="(data, index) in productsdatelist"
                                      :key="data.PREORDERPRODUCTID"
                                    >
                                      <td class="has-text-centered">
                                        {{ index + 1 }}
                                      </td>
                                      <td>
                                        {{ data.PRODUCTNAME }}
                                        {{ data.PRODUCTNAME_SUB }}
                                        ({{ data.PREORDERPRODUCTID }}/{{
                                          data.PRODUCTID
                                        }}/{{ data.PRODUCTID_SUB }}
                                        )

                                        <div>
                                          <img
                                            data-v-xcxcc
                                            :src="getImgUrl(data.IMAGEURL)"
                                            width="100"
                                            height="100"
                                          />
                                        </div>
                                      </td>
                                      <td class="has-text-left">
                                        ເປີດຈອງ:
                                        {{ data.QUANTITY | formatNumberLocal
                                        }}<br />
                                        ຍັງເຫຼືອ:
                                        {{ data.QUANTITY - data.QUANTITYORDERED | formatNumberLocal
                                        }}<br />
                                        ຈອງມາ:
                                        {{
                                          data.QUANTITYORDERED
                                            | formatNumberLocal
                                        }}<br />
                                        ຈັດສັນ:
                                        {{
                                          data.QUANTITYPREPARED
                                            | formatNumberLocal
                                        }}<br />

                                        <b-button
                                          v-if="
                                            data.QUANTITY_PROVIDED_NULL > 0 &&
                                              selectedpreorderdatestatus == 1
                                          "
                                          class="btn-group-margin"
                                          type="is-warning"
                                          size="is-small"
                                          >ບໍ່ຜ່ານການກວດສິນຄ້າຍ່ອຍ
                                        </b-button>
                                        <b-button
                                          v-else
                                          class="btn-group-margin"
                                          type="is-success"
                                          size="is-small"
                                          >ຜ່ານ 
                                        </b-button>

                                        <!-- <b-button
                                          v-if="
                                              selectedpreorderdatestatus == 1
                                          "
                                          class="btn-group-margin"
                                          type="is-success"
                                          size="is-small"
                                          >ຜ່ານ
                                        </b-button> -->

                                        <!-- <b-button
                                          v-if="
                                            data.ISPASSED != 1 &&
                                              selectedpreorderdatestatus == 1
                                          "
                                          class="btn-group-margin"
                                          type="is-warning"
                                          size="is-small"
                                          >ບໍ່ຜ່ານ - {{data.ISPASSED}} -- {{ selectedpreorderdatestatus }}
                                        </b-button> -->
                                      </td>

                                      <td class="has-text-right">
                                        {{ data.UNITPRICE | formatNumberLocal }}
                                      </td>

                                      <td class="has-text-right">
                                        <button
                                          class="button is-info is-small"
                                          @click="
                                            preorderproductdetail(
                                              data.PREORDERPRODUCTID,
                                              data.PRODUCTNAME,
                                              data.PRODUCTNAME_SUB
                                            )
                                          "
                                        >
                                          ລາຍລະອຽດ
                                        </button>
                                        <br />
                                        <b-button
                                          v-if="selectedpreorderdatestatus == 1 "
                                          class="btn-group-margin"
                                          type="is-primary"
                                          size="is-small"
                                          @click="
                                            updatePreOrderProductForm(
                                              data,
                                              selectedpreorderdatestatus
                                            )
                                          "
                                          >ແກ້ໄຂ
                                        </b-button>
                                        <br />
                                        <button
                                          v-if="
                                            todate <= selectedsenddate &&
                                              selectedpreorderdatestatus == 1 &&
                                              data.QUANTITYORDERED < 1
                                          "
                                          class="button is-danger is-small"
                                          @click="
                                            removeProduct(
                                              data.PREORDERPRODUCTID
                                            )
                                          "
                                        >
                                          ຍົກເລີກສິນຄ້າ
                                        </button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>

                              <div class="column">
                                <div v-if="isPreorderproductdetail">
                                  <h3 class="subtitle-bold">
                                    ລາຍລະອຽດ {{ PreorderproductdetailTitle }}
                                  </h3>
                                  <h2>
                                    {{ selectedPreorderProductid }}
                                    {{ preorderProductName }}
                                    {{ preorderProductName_Sub }}
                                  </h2>

                                  <table width="100%" class="table ">
                                    <thead>
                                      <tr>
                                        <th
                                          class="has-text-centered "
                                          width="5%"
                                        >
                                          #
                                        </th>
                                        <th class="has-text-left " width="30%">
                                          ລູກຄ້າ
                                        </th>
                                        <th class="has-text-right" width="30%">
                                          ຈຳນວນ
                                        </th>
                                        <th
                                          class="has-text-centered"
                                          width="30%"
                                        >
                                          ຈຳນວນ <br />
                                          ທີ່ຈັດສັນ
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(data,
                                        index) in preorderProductdetaillist"
                                        :key="data.ID"
                                      >
                                        <td class="has-text-centered">
                                          {{ index + 1 }}
                                        </td>
                                        <td>
                                          {{ data.PREORDERID }} / {{ data.PREORDERDETAILID }}
                                          <span
                                            v-html="data.CUSTOMERNAME"
                                          ></span
                                          ><br />
                                          <span v-html="data.CUSTOMERID"></span>
                                        </td>
                                        <td class="has-text-right">
                                          {{
                                            data.QUANTITY | formatNumberLocal
                                          }}
                                        </td>
                                        <td class="has-text-centered">
                                          <b-field grouped style="width: 100%">
                                            <b-field
                                              style="width: 40%; text-align: right;"
                                            >
                                              <b-input
                                                type="number"
                                                v-model.trim="
                                                  data.QUANTITY_PROVIDED
                                                "
                                                v-if="
                                                  data.QUANTITYPROVIDED_DB ==
                                                    null
                                                "
                                              >
                                              </b-input>

                                              <b-field
                                                v-if="
                                                  data.QUANTITYPROVIDED != null
                                                "
                                              >
                                                <b-field
                                                  class="statusLabel-organge"
                                                  v-if="
                                                    data.QUANTITY <
                                                      data.QUANTITYPROVIDED
                                                  "
                                                >
                                                </b-field>
                                                <b-field
                                                  v-if="
                                                    data.QUANTITY >=
                                                      data.QUANTITYPROVIDED &&
                                                      data.QUANTITYPROVIDED_DB !=
                                                        null
                                                  "
                                                >
                                                  {{ data.QUANTITYPROVIDED }}
                                                </b-field>
                                              </b-field>
                                            </b-field>
                                            <b-field style="width: 60%">
                                              <b-button
                                                v-if="
                                                  data.QUANTITYPROVIDED == null
                                                "
                                                class="btn-group-margin"
                                                type="is-primary is-small"
                                                @click="saveQuantityProvide()"
                                                >ບັນທືກ
                                              </b-button>
                                              <b-button
                                                v-if="
                                                  data.QUANTITYPROVIDED !=
                                                    null &&
                                                    data.STATUS == 1
                                                    && data.ORDERSTATUS == 1
                                                "
                                                class="btn-group-margin"
                                                type="is-danger is-small"
                                                @click="clearQuantityProvide()"
                                                >ລ້າງຂໍ້ມູນ
                                              </b-button>
                                            </b-field>
                                          </b-field>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>

                                <div v-if="isPreorderproductalldetail">
                                  <h3 class="subtitle-bold">
                                    ລາຍລະອຽດ {{ PreorderproductalldetailTitle }}
                                  </h3>
                                  <!-- <h2>
                                    {{ preorderProductName }}
                                    {{ preorderProductName_Sub }}
                                  </h2> -->
                                  <table width="100%" class="table ">
                                    <thead>
                                      <tr>
                                        <th
                                          class="has-text-centered "
                                          width="5%"
                                        >
                                          #
                                        </th>
                                        <th class="has-text-left " width="30%">
                                          ສິນຄ້າ
                                        </th>
                                        <th class="has-text-right" width="20%">
                                          ຈຳນວນ
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(data,
                                        index) in preorderProductalldetaillist"
                                        :key="data.ID"
                                      >
                                        <td class="has-text-centered">
                                          {{ index + 1 }}
                                        </td>
                                        <td>
                                          <!-- <span v-html="data.CUSTOMERID"></span> -->
                                          {{ data.PRODUCTNAME }}
                                          {{ data.PRODUCTNAME_SUB }}
                                        </td>
                                        <td class="has-text-right">
                                          {{
                                            data.QUANTITY | formatNumberLocal
                                          }}
                                          ({{ data.ENUNIT }})
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>

                                <div v-if="isProductforbuy">
                                  <h3 class="subtitle-bold">
                                    ລາຍລະອຽດ {{ ProductforbuyTitle }}
                                  </h3>
                                  <b-field
                                    style=" text-align: right;"
                                    v-if="productforbuylist.length > 0"
                                  >
                                    <b-button
                                      v-if="
                                        productforbuylist[0].GOTQUANTITY !=
                                          null &&
                                          productforbuylist[0].STATUS == 1 && selectedpreorderdatestatus ==1
                                      "
                                      class="btn-group-margin"
                                      type="is-primary is-small"
                                      @click="settletoProductGrading()"
                                      >ເອົາສິນຄ້າເຂົ້າໄປລະບົບຂາຍ (ປ້ອນເກດ)
                                    </b-button>
                                    <b-field
                                      v-if="productforbuylist[0].STATUS == 2"
                                      class="statusLabel-pink"
                                    >
                                      ສິນຄ້າເຂົ້າລະບົບຂາຍແລ້ວ -
                                      {{ selectedpreorderdateid }}
                                    </b-field>
                                  </b-field>

                                  <!-- <table width="100%" class="table ">
                                    <thead>
                                      <tr>
                                        <th
                                          class="has-text-centered "
                                          width="5%"
                                        >
                                          #
                                        </th>
                                        <th class="has-text-left " width="20%">
                                          ສິນຄ້າ
                                        </th>
                                        <th class="has-text-right" width="20%">
                                          ຈຳນວນ<br />ທີ່ສັ່ງ
                                        </th>
                                        <th
                                          class="has-text-centered"
                                          width="30%"
                                        >
                                          ຈຳນວນ<br />ທີ່ຫາໄດ້
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(data,
                                        index) in productforbuylist"
                                        :key="data.ID"
                                      >
                                        <td class="has-text-centered">
                                          {{ index + 1 }}
                                        </td>
                                        <td>
                                          {{ data.PRODUCTID }}
                                          {{ data.PRODUCTNAME }}
                                        </td>
                                        <td class="has-text-right">
                                          {{
                                            data.QUANTITY | formatNumberLocal
                                          }}
                                          {{ data.UNIT }}
                                        </td>
                                        <td class="has-text-centered">
                                          <b-field grouped style="width: 100%">
                                            <b-field
                                              style="width: 40%; text-align: right;"
                                            >
                                              <b-input
                                                v-model.trim="data.GOT_QUANTITY"
                                                v-if="data.GOTQUANTITY == null"
                                              >
                                              </b-input>
                                              <b-field
                                                v-if="data.GOTQUANTITY > 0"
                                              >
                                                <b-field
                                                  class="statusLabel-organge"
                                                  v-if="
                                                    data.GOTQUANTITY !=
                                                      data.PRE_QUANTITY
                                                  "
                                                >
                                                  {{ data.GOTQUANTITY }} /
                                                  {{ data.PRE_QUANTITY }}
                                                </b-field>
                                                <b-field
                                                  v-if="
                                                    data.GOTQUANTITY ==
                                                      data.PRE_QUANTITY
                                                  "
                                                >
                                                  {{ data.GOTQUANTITY }} /
                                                  {{ data.PRE_QUANTITY }}
                                                </b-field>
                                              </b-field>
                                            </b-field>
                                            <b-field style="width: 60%">
                                              <b-button
                                                v-if="data.GOTQUANTITY == null"
                                                class="btn-group-margin"
                                                type="is-primary is-small"
                                                @click="saveGotProductAmount()"
                                                >ບັນທືກ
                                              </b-button>
                                              <b-button
                                                v-if="
                                                  data.GOTQUANTITY > 0 &&
                                                    data.STATUS == 1 && selectedpreorderdatestatus ==1
                                                "
                                                class="btn-group-margin"
                                                type="is-danger is-small"
                                                @click="clearGotProductAmount()"
                                                >ລ້າງຂໍ້ມູນ
                                              </b-button>
                                            </b-field>
                                          </b-field>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table> -->
                                   
                                  <div style=" float: right;margin-bottom: 5px;" class="no-print">
                                  <b-button class="is-small" type="is-info" @click="print()">ພິມ</b-button>
                                </div>
                                  <table width="100%" class="table no-print">
                                    <thead>
                                      <tr>
                                        <th
                                          class="has-text-centered "
                                          width="5%"
                                        >
                                          #
                                        </th>
                                        <th class="has-text-left " width="20%">
                                          ສິນຄ້າ
                                        </th>
                                        <th class="has-text-right" width="20%">
                                          ຈຳນວນ<br />ທີ່ສັ່ງ
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(data,
                                        index) in productforbuylist"
                                        :key="data.ID"
                                      >
                                        <td class="has-text-centered">
                                          {{ index + 1 }}
                                        </td>
                                        <td>
                                          {{ data.PRODUCTID }}
                                          {{ data.PRODUCTNAME }}
                                        </td>
                                        <td class="has-text-right">
                                          {{
                                            data.QUANTITY | formatNumberLocal
                                          }}
                                          {{ data.UNIT }}
                                        </td>
                                        
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div v-if="isCustomenotgetanyproduct">
                                  <h3 class="subtitle-bold">
                                    ລາຍລະອຽດ {{ customernotgetanyproductTitle }}
                                  </h3>

                                  <table width="100%" class="table ">
                                    <thead>
                                      <tr>
                                        <th
                                          class="has-text-centered "
                                          width="5%"
                                        >
                                          #
                                        </th>
                                        <th class="has-text-left " width="20%">
                                          ລູກຄ້າ
                                        </th>
                                        <th class="has-text-right" width="20%">
                                          ຈຳນວນສິນຄ້າທີ່ສັ່ງ
                                        </th>
                                        <th class="has-text-right" width="30%">
                                          ແຈ້ງລູກຄ້າ
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(data,
                                        index) in customernotgetanyproductlist"
                                        :key="data.CUSTOMERID"
                                      >
                                        <td class="has-text-right">
                                          {{ index + 1 }}
                                        </td>
                                        <td>
                                          <!-- <span v-html="data.CUSTOMERID"></span> -->
                                          {{ data.CUSTOMERNAME }}<br />
                                          {{ data.PHONENO }}
                                        </td>
                                        <td class="has-text-right">
                                          {{ data.ORDERED | formatNumberLocal }}
                                        </td>
                                        <td class="has-text-right">
                                          <!-- <b-button
                                            v-if="data.isInformNoProduct == 0"
                                            class="btn-group-margin"
                                            type="is-primary is-small"
                                            @click="
                                              informCustomer(data.CUSTOMERID)
                                            "
                                            >ແຈ້ງລູກຄ້າ
                                          </b-button> -->
                                          <span
                                            v-if="data.isInformNoProduct == 1"
                                            >ແຈ້ງລູກຄ້າແລ້ວ</span
                                          ><span style="color:red"
                                            v-else
                                            >ຍັງບໍ່ທັນແຈ້ງລູກຄ້າ</span
                                          >
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>

                                <div v-if="isPreordercustomerdetail">
                                  <h3 class="subtitle-bold">
                                    ລາຍລະອຽດ {{ PreordercustomerdetailTitle }}
                                  </h3>
                                  <table width="100%" class="table ">
                                    <thead>
                                      <tr>
                                        <th
                                          class="has-text-centered "
                                          width="5%"
                                        >
                                          #
                                        </th>
                                        <th class="has-text-left " width="30%">
                                          ລູກຄ້າ
                                        </th>
                                        <th
                                          class="has-text-centered"
                                          width="60%"
                                        >
                                          ລາຍການທີ່ສັ່ງ
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(data,
                                        index) in preorderCustomerdetaillist"
                                        :key="data.ORDERID"
                                      >
                                        <td class="has-text-centered">
                                          {{ index + 1 }}
                                        </td>
                                        <td>
                                          Preorder No: {{ data.ORDERID }} <br />
                                          Order No: {{ data.REALORDERID }} <br />
                                          {{ data.CUSTOMERNAME }}
                                          <br />
                                          {{ data.CUSTOMERID }}<br />
                                          <b-button
                                            v-if="
                                              // selectedpreorderdatestatus == 1 &&
                                              //   isOrderPrepare == false &&
                                              data.NOTSETQUANTITY == 0
                                              && data.REALORDERID == null && data.ISZEROPROVIDE == 0
                                            "
                                            class="btn-group-margin"
                                            type="is-danger"
                                            size="is-small"
                                            @click="
                                              PrepareToSingleOrder(
                                                data.ORDERID,
                                                data.CUSTOMERID
                                              )
                                            "
                                            >ກວດສອບກ່ອນ Process to Order
                                          </b-button>
                                          <!-- {{  data.NOTSETQUANTITY }} - {{ data.REALORDERID }} - {{ data.ISZEROPROVIDE}} -->

                                          <b-button
                                            v-if="
                                              // selectedpreorderdatestatus == 1 &&
                                              //   isOrderPrepare == false &&
                                              data.ISZEROPROVIDE == 1
                                            "
                                            class="btn-group-margin"
                                            type="is-warning"
                                            size="is-small"
                                            @click="
                                              CancelPreorder(
                                                data.ORDERID
                                              )
                                            "
                                            >ບໍ່ໄດ້ສິນຄ້າຈັກລາຍການ, ໂທແຈ້ງລູກຄ້າ
                                          </b-button>

                                          <b-button
                                            v-if="
                                              // selectedpreorderdatestatus == 1 &&
                                              //   isOrderPrepare == false &&
                                              data.NOTSETQUANTITY == 0 &&
                                                data.COUNTALLCOMPARE > 0 &&
                                                data.COUNTALLCOMPARENOTPASS == 0
                                                && data.REALORDERID == null
                                            "
                                            class="btn-group-margin"
                                            type="is-info"
                                            size="is-small"
                                            @click="
                                              processPreorderToSingleOrder(
                                                data.ORDERID,
                                                data.CUSTOMERID
                                              )
                                            "
                                          >
                                            Process to Order
                                          </b-button>
                                          <span
                                            v-if="
                                              data.REALORDERID != null
                                            "
                                            class="statusLabel-passed"
                                          >
                                            Process to Order ສຳເລັດ
                                          </span>
                                        </td>
                                        <td class="has-text-left">
                                          <!-- <span
                                            v-html="
                                              arraySplit(data.PREORDERPRODUCTS)
                                            "
                                          ></span> -->
                                          <table width="100%" class="table">
                                            <thead>
                                              <tr>
                                                <td>ສິນຄ້າ</td>
                                                <td>ຈອງມາ/ ຈັດໃຫ້</td>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr
                                                v-for="product in customerProducts"
                                                :key="
                                                  product.PRODUCTID +
                                                    '-' +
                                                    product.ORDERID
                                                "
                                              >
                                                <td
                                                  v-if="
                                                    product.ORDERID ===
                                                      data.ORDERID
                                                  "
                                                >
                                                  {{ product.PRODUCTNAME }}
                                                  ({{ product.UNIT }})
                                                </td>

                                                <td
                                                  v-if="
                                                    product.ORDERID ===
                                                      data.ORDERID
                                                  "
                                                >
                                                  <span
                                                    v-if="
                                                      product.QUANTITY_PROVIDED ===
                                                        null
                                                    "
                                                    class="statusLabel-pink"
                                                  >
                                                    {{ product.QUANTITY }} / - -
                                                    - -
                                                  </span>

                                                  <span
                                                    v-if="
                                                      product.QUANTITY_PROVIDED ==
                                                        0 ||
                                                        (product.QUANTITY !=
                                                          product.QUANTITY_PROVIDED &&
                                                          product.QUANTITY_PROVIDED !=
                                                            null)
                                                    "
                                                    class="statusLabel-organge"
                                                  >
                                                    {{ product.QUANTITY }} /
                                                    {{
                                                      product.QUANTITY_PROVIDED
                                                    }}
                                                  </span>

                                                  <span
                                                    v-if="
                                                      product.QUANTITY_PROVIDED &&
                                                        product.QUANTITY ==
                                                          product.QUANTITY_PROVIDED
                                                    "
                                                    class="statusLabel-passed"
                                                  >
                                                    {{ product.QUANTITY }} /
                                                    {{
                                                      product.QUANTITY_PROVIDED
                                                    }}
                                                  </span>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <!-- <div
                                            v-for="product in customerProducts"
                                            :key="product.PRODUCTID"
                                          >
                                            <div
                                              v-if="
                                                product.CUSTOMERID ===
                                                  data.CUSTOMERID
                                              "
                                            >
                                              {{ product.PRODUCTNAME }}:
                                              <span
                                                v-if="
                                                  product.QUANTITY !=
                                                    product.QUANTITY_PROVIDED
                                                "
                                                class="statusLabel-organge"
                                              >
                                                {{ product.QUANTITY }}
                                                /
                                                {{
                                                  product.QUANTITY_PROVIDED ||
                                                  product.QUANTITY_PROVIDED == 0
                                                    ? product.QUANTITY_PROVIDED
                                                    : "----"
                                                }}
                                              </span>

                                              <span
                                                v-if="
                                                  product.QUANTITY ==
                                                    product.QUANTITY_PROVIDED
                                                "
                                                class="statusLabel-passed"
                                              >
                                                {{ product.QUANTITY }}
                                                /
                                                {{ product.QUANTITY_PROVIDED }}
                                              </span>

                                              {{ product.UNIT }}
                                            </div>
                                          </div> -->
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </b-tab-item>
                        <b-tab-item label="ຟອມແກ້ໄຂສິນຄ້າ">
                          <div class="container">
                            <div class="columns">
                              <div class="column">
                                <h3 class="subtitle-bold">
                                  ຟອມແກ້ໄຂສິນຄ້າ
                                </h3>
                              </div>
                            </div>
                            <div class="columns">
                              <div class="column">
                                <div class="columns">
                                  <div class="column">
                                    <b-field label="ຊື່ສິນຄ້າ">
                                      {{ updateProductname }}
                                      {{ updateProductnameSub }}
                                    </b-field>
                                  </div>
                                  <div class="column">
                                    <b-field
                                      label="ຈຳນວນ"
                                      v-if="
                                        selecteQuantityOrdered < updateAmount
                                      "
                                    >
                                      <b-input v-model.trim="updateAmount">
                                      </b-input>
                                    </b-field>
                                    <b-field
                                      label="ຈຳນວນ"
                                      v-if="
                                        selecteQuantityOrdered >= updateAmount
                                      "
                                    >
                                      {{ updateAmount }}
                                    </b-field>
                                  </div>
                                  <div class="column">
                                    <b-field
                                      label="ລາຄາ"
                                      v-if="selectedpreorderdatestatus == 1"
                                    >
                                      <b-input v-model.trim="updatePrice">
                                      </b-input>
                                    </b-field>
                                    <b-field
                                      label="ລາຄາ"
                                      v-if="selectedpreorderdatestatus == 2"
                                    >
                                      {{ updatePrice }}
                                    </b-field>
                                  </div>
                                </div>
                                <div class="columns">
                                  <div class="column"></div>
                                  <div class="column">
                                    <!-- <b-field grouped position="is-right">
                                      <div class="buttons">
                                        <b-button
                                          expanded
                                          type="is-primary"
                                          onclick="document.getElementById('fileupload').click()"
                                          >ເລືອກຮູບ
                                        </b-button>
                                      </div>
                                    </b-field> -->
                                    <b-field label="" style="float: right">
                                      <b-field>
                                        <div class="columns">
                                          <div class="column">
                                            <b-field>
                                              <button
                                                class="button is-primary"
                                                @click="updatePreOrderProduct"
                                              >
                                                ແກ້ໄຂສິນຄ້າ
                                              </button>
                                            </b-field>
                                          </div>
                                        </div>
                                      </b-field>
                                    </b-field>
                                  </div>
                                </div>
                                <!-- <div class="columns">
                                  <div class="column">
                                    <b-field
                                      grouped
                                      position="is-centered"
                                    >
                                      <img
                                        data-v-xcxcc
                                        :src="photopreview"
                                        width="500"
                                        height="500"
                                      />
                                    </b-field>
                                    <input
                                      type="file"
                                      id="fileupload"
                                      @change="onFileSelected"
                                      style="visibility:hidden;"
                                    />
                                  </div>
                                </div> -->
                              </div>
                            </div>
                          </div>
                        </b-tab-item>

                        <!-- <b-tab-item label="ລາຍລະອຽດການສັ່ງ PreOrder">
                          <div class="container">
                            <div class="columns">
                              <div class="column">
                                <h3 class="subtitle-bold">
                                  ລາຍລະອຽດການສັ່ງ PreOrder
                                </h3>
                              </div>
                            </div>
                            <div class="columns">
                              <div class="column">
                                <table width="20%" class="table borderless">
                                  <tr>
                                    <td>
                                      ວັນທີ ເລີ່ມຮັບອໍເດີ້:
                                    </td>
                                    <td>
                                      {{ dateFormatter(selectedstartdate) }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      ວັນທີ ສິ້ນສຸດຮັບອໍເດີ້:
                                    </td>
                                    <td>
                                      {{ dateFormatter(selectedenddate) }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      ວັນທີ ສົ່ງສິນຄ້າ:
                                    </td>
                                    <td>
                                      {{ dateFormatter(selectedsenddate) }}
                                    </td>
                                  </tr>
                                </table>

                                <button
                                  class="button is-info is-small"
                                  @click="preordercustomerdetail()"
                                >
                                  ແຍກຕາມລູກຄ້າ
                                </button>
                              </div>
                            </div>
                            <div class="columns">
                              <div class="column">
                                <table width="100%" class="table ">
                                  <thead>
                                    <tr>
                                      <th class="has-text-centered " width="5%">
                                        #
                                      </th>
                                      <th class="has-text-left " width="30%">
                                        ສິນຄ້າ
                                      </th>
                                      <th class="has-text-right" width="30%">
                                        ຈຳນວນເປີດ <br />ຈຳນວນສັ່ງຈອງ
                                      </th>
                                      <th class="has-text-right" width="15%">
                                        ລາຄາ
                                      </th>
                                      <th class="has-text-right" width="15%">
                                        ລາຍລະອຽດ
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr
                                      v-for="(data, index) in productsdatelist"
                                      :key="data.PREORDERPRODUCTID"
                                    >
                                      <td class="has-text-centered">
                                        {{ index + 1 }}
                                      </td>
                                      <td>
                                        {{ data.PRODUCTNAME }}
                                        {{ data.PRODUCTNAME_SUB }} (
                                        {{ data.ID }}-{{ data.PRODUCTID }} )

                                        <div>
                                          <img
                                            data-v-xcxcc
                                            :src="getImgUrl(data.IMAGEURL)"
                                            width="100"
                                            height="100"
                                          />
                                        </div>
                                      </td>
                                      <td class="has-text-right">
                                        {{ data.QUANTITY | formatNumberLocal }}
                                        <br />{{
                                          data.QUANTITYORDERED
                                            | formatNumberLocal
                                        }}
                                      </td>
                                      <td class="has-text-right">
                                        {{ data.UNITPRICE | formatNumberLocal }}
                                      </td>

                                      <td class="has-text-right">
                                        <button
                                          class="button is-info is-small"
                                          @click="
                                            preorderproductdetail(
                                              data.PREORDERPRODUCTID,
                                              data.PRODUCTNAME,
                                              data.PRODUCTNAME_SUB
                                            )
                                          "
                                        >
                                          ລາຍລະອຽດ
                                        </button>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>

                              <div class="column">
                                <div v-if="isPreorderproductdetail">
                                  <h3 class="subtitle-bold">ລາຍລະອຽດ</h3>
                                  <h2>
                                    {{ preorderProductName }}
                                    {{ preorderProductName_Sub }}
                                  </h2>
                                  <table width="100%" class="table ">
                                    <thead>
                                      <tr>
                                        <th
                                          class="has-text-centered "
                                          width="5%"
                                        >
                                          #
                                        </th>
                                        <th class="has-text-left " width="30%">
                                          ລູກຄ້າ
                                        </th>
                                        <th class="has-text-right" width="30%">
                                          ຈຳນວນ
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(data,
                                        index) in preorderProductdetail"
                                        :key="data.ID"
                                      >
                                        <td class="has-text-centered">
                                          {{ index + 1 }}
                                        </td>
                                        <td>
                                          <span v-html="data.CUSTOMERID"></span>
                                        </td>
                                        <td class="has-text-right">
                                          {{
                                            data.QUANTITY | formatNumberLocal
                                          }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>

                                <div v-if="isPreordercustomerdetail">
                                  <h3 class="subtitle-bold">ລາຍລະອຽດ</h3>
                                  <table width="100%" class="table ">
                                    <thead>
                                      <tr>
                                        <th
                                          class="has-text-centered "
                                          width="5%"
                                        >
                                          #
                                        </th>
                                        <th class="has-text-left " width="30%">
                                          ລູກຄ້າ
                                        </th>
                                        <th
                                          class="has-text-centered"
                                          width="30%"
                                        >
                                          ລາຍການສັ່ງ
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(data,
                                        index) in preorderCustomerdetaillist"
                                        :key="data.CUSTOMERID"
                                      >
                                        <td class="has-text-centered">
                                          {{ index + 1 }}
                                        </td>
                                        <td>
                                          {{ data.CUSTOMERID }}
                                        </td>
                                        <td class="has-text-left">
                                          <span
                                            v-html="
                                              arraySplit(data.PREORDERPRODUCTS)
                                            "
                                          ></span>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </b-tab-item> -->
                      </b-tabs>
                    </b-tab-item>
                  </b-tabs>
                </div>
              </div>
              <!-- <b-field v-if="!isActiveQuotaForm">

                
                
                
              </b-field> -->
              <!-- <b-field v-if="isActiveQuotaForm">
              
              </b-field> -->
            </div>
          </b-field>
        </b-tab-item>
      </b-tabs>
    </div>

    <div class="contain print-only">
      <div class="column">
        <h3 class="title">{{ marketname }}</h3>
      </div>
      <div class="column">
        <table width="20%" class="table borderless">
          <tr>
            <td>
              ວັນທີ ເລີ່ມຮັບອໍເດີ້:
            </td>
            <td>
              {{ dateFormatter(selectedstartdate) }}
            </td>
          </tr>
          <tr>
            <td>
              ວັນທີ ສິ້ນສຸດຮັບອໍເດີ້:
            </td>
            <td>
              {{ dateFormatter(selectedenddate) }}
            </td>
          </tr>
          <tr>
            <td>
              ວັນທີ ສົ່ງສິນຄ້າ:
            </td>
            <td>
              {{ dateFormatter(selectedsenddate) }}
            </td>
          </tr>
        </table>
      </div>
      <div class="column">
        <table width="100%" class="table ">
        <thead>
          <tr>
            <th
              class="has-text-centered "
              width="5%"
            >
              #
            </th>
            <th class="has-text-left " width="20%">
              ສິນຄ້າ
            </th>
            <th class="has-text-right" width="20%">
              ຈຳນວນທີ່ສັ່ງ
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(data,
            index) in productforbuylist"
            :key="data.ID"
          >
            <td class="has-text-centered">
              {{ index + 1 }}
            </td>
            <td>
              {{ data.PRODUCTID }}
              {{ data.PRODUCTNAME }}
            </td>
            <td class="has-text-right">
              {{
                data.QUANTITY | formatNumberLocal
              }}
              {{ data.UNIT }}
            </td>
            
          </tr>
        </tbody>
      </table>
      </div>
      
    </div>

      

  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
// import Multiselect from "vue-multiselect";
import moment from "moment";
import axios from "axios";

export default {
  // components: { Multiselect },
  props: ["MONTH"],
  data() {
    return {
      userName: null,
      roleid: null,
      activemarkets: [],
      marketid: null,
      marketname: null,
      sellerid: null,

      activeTab: 0,
      saveAction: true,
      updateAction: false,
      adddataform: true,
      updatedataform: false,

      activeSubTab: 0,
      productType: [],
      products: [],
      productamount: [],
      selecteddate: null,
      prequota: [],

      activeSubSubTab: 0,
      updateProductname: null,
      updateProductnameSub: null,
      updateAmount: null,
      updatePrice: null,
      updatePreOrderProductid: null,

      preorder_startdate: null,
      preorder_enddate: null,
      preorder_senddate: null,

      selectedpreorderdateid: null,
      selectedpreorderdatestatus: null,
      selectedstartdate: null,
      selectedenddate: null,
      selectedsenddate: null,
      sellectedsellerid: null,
      productsdatelist: [],
      preorderdetail: [],

      selecteQuantityOrdered: null,

      activeFormTab: 0,

      activeWaitTab: 0,

      quotaltoproduction: [],
      activeQuotaSubTab: 0,
      quotadate: null,
      quotadatetypes: null,
      quotadateproducts: null,
      selectedquotaddate: null,

      dateproductions: [],

      isActiveQuotaForm: true,
      preQuotaList: [],
      postQuotaList: [],
      isPreQuotaDetail: false,
      preQuotaProductList: [],
      postQuotaProductList: [],
      selectedRedate: null,
      preorderdatelist: [],
      selectedpreorderdate: null,

      farmerList: [],
      marketSelectedDate: null,

      selectedProductionid: null,
      farmerProductionList: [],
      isFarmerProduction: false,
      farmerProductionFarmername: null,
      farmerProductionRequestID: null,
      farmerProductionRedate: null,
      farmerProductionGetplandate: null,
      farmerProductionID: null,
      farmerProductionFarmID: null,
      farmerProductionFarmerID: null,
      farmerProductionTotalAmount: null,
      farmerProductionProductid: null,
      farmerProductionProductname: null,
      farmerProductionUnit: null,
      farmerProductionAmount: null,
      farmerProductionRecommentdate: null,
      farmerProductionProdate: null,
      farmerProductionProamount: null,
      farmerProductionHarvestdate: null,
      farmerProductionHarvestamount: null,
      farmerProductionProstatus: null,
      selectedAction: null,

      actionAmount: 0,
      actionDate: null,
      reportDate: null,
      selectedProductionAction: null,
      productionActionList: [
        { ACTIONID: "0", ACTIONNAME: "ເລືອກ" },
        { ACTIONID: "1", ACTIONNAME: "ເລີ່ມຜະລິດ" },
        { ACTIONID: "2", ACTIONNAME: "ເກັບກ່ຽວ" },
      ],
      productionReportDetail: null,
      productionReportList: [],

      waitstatus: null,

      isPreorderproductdetail: false,
      isPreorderproductalldetail: false,
      isProductforbuy: false,
      isPreordercustomerdetail: false,
      isCustomenotgetanyproduct: false,

      PreorderproductalldetailTitle: "ແຍກຕາມສິນຄ້າ",
      ProductforbuyTitle: "ສັງລວມເພື່ອຈັດຊື້",
      PreordercustomerdetailTitle: "ແຍກຕາມລູກຄ້າ ແລະ Process Order",
      PreorderproductdetailTitle: "ແຍກຕາມສິນຄ້າຍ່ອຍ",
      customernotgetanyproductTitle: "ລູກຄ້າທີ່ບໍ່ໄດ້ສິນຄ້າຈັກລາຍການ",

      preorderProductdetaillist: [],
      preorderCustomerdetaillist: [],
      preorderProductalldetaillist: [],
      productforbuylist: [],
      preorderProductName: null,
      preorderProductName_Sub: null,
      isOrderPrepare: false,
      customernotgetanyproductlist: [],

      selectedPreorderProductid: null,
      selectedPreorderProductname: null,
      selectedPreorderproductnamesub: null,

      selectedFile: null,
      url: "uploadpreorderimage", // function name in api site
      photoname: null,
      photopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/manager-main/api/uploads/products/"
          : "http://localhost/agrilao-manager/api/uploads/products/",
      // photopath: process.env.NODE_ENV === "production" ? "http://51.222.85.54/agrilao-manager/api/uploads/products/" : "http://localhost/agrilao-manager/api/uploads/products/",
      photopreview: null,

      todate: null,
      search: null,
      customerProducts: [],
    };
  },
  methods: {
    arraySplit(arr) {
      var data = arr.split(",");
      var newdata = "";
      data.forEach((d) => {
        newdata = newdata + d + "<br>";
      });
      return newdata;
    },
    removeProduct(PREORDERPRODUCTID) {
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການຕໍ່ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            preorderProductid: PREORDERPRODUCTID,
            username: this.username,
          };
          // console.log("params: " + JSON.stringify(params));

          RestAPI.removeProductPreorderProduct(params)
            .then(() => {
              this.productsdatedetail(
                this.selectedpreorderdateid,
                this.selectedstartdate,
                this.selectedenddate,
                this.selectedsenddate,
                this.selectedpreorderdatestatus,
                this.sellectedsellerid
              );
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    preorderproductdetail(preorderProductid, productname, productnamesub) {
      this.isPreorderproductdetail = true;
      this.isPreordercustomerdetail = false;
      this.isProductforbuy = false;
      (this.isPreorderproductalldetail = false),
        (this.preorderProductName = productname);
      this.isCustomenotgetanyproduct = false;
      this.preorderProductName_Sub = productnamesub;
      this.selectedPreorderProductid = preorderProductid;
      this.selectedPreorderProductname = productname;
      this.selectedPreorderproductnamesub = productnamesub;

      RestAPI.getPreorderProductDetail(preorderProductid)
        .then((res) => {
          // console.log("res.data: " + JSON.stringify(res.data));
          this.preorderProductdetaillist = res.data;
          window.scrollTo({ top: 500, behavior: "smooth" });
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    saveQuantityProvide() {
      //  console.log("this.formdate: "+ this.formdate)

      var params = {
        preorderproductid: this.selectedPreorderProductid,
        products: this.preorderProductdetaillist,
        username: this.username,
        marketid: this.marketid
      };

      console.log("params:- ", JSON.stringify(params));

      RestAPI.savePreorderQuantityProvide(params)
        .then(res => {

          if(res.data.error!=0){
            this.$swal("ມີບາງລາຍການ ເກີນຈຳນວນສັ່ງຊື້", "", "warning");
          }
          this.preorderproductdetail(
            this.selectedPreorderProductid,
            this.selectedPreorderProductname,
            this.selectedPreorderproductnamesub
          );

          // reload
          this.reloadAfterProvidedProduct();

          // this.productsdatedetail(
          //   this.selectedpreorderdateid,
          //   this.selectedstartdate,
          //   this.selectedenddate,
          //   this.selectedsenddate,
          //   this.selectedpreorderdatestatus,
          //   this.sellectedsellerid
          // );
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    clearQuantityProvide() {
      //  console.log("this.formdate: "+ this.formdate)
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການຕໍ່ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            preorderProductid: this.selectedPreorderProductid,
            username: this.username,
          };

          RestAPI.clearPreorderQuantityProvide(params)
            .then(() => {
              this.preorderproductdetail(
                this.selectedPreorderProductid,
                this.selectedPreorderProductname,
                this.selectedPreorderproductnamesub
              );

              // reload
              this.reloadAfterProvidedProduct();
              // this.productsdatedetail(
              //   this.selectedpreorderdateid,
              //   this.selectedstartdate,
              //   this.selectedenddate,
              //   this.selectedsenddate,
              //   this.selectedpreorderdatestatus,
              //   this.sellectedsellerid
              // );
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    preordercustomerdetail() {
      this.isPreorderproductdetail = false;
      this.isPreordercustomerdetail = true;
      this.isPreorderproductalldetail = false;
      this.isProductforbuy = false;
      this.isCustomenotgetanyproduct = false;
      RestAPI.getPreorderCustomerDetail(this.selectedpreorderdateid)
        .then((res) => {
          // console.log("res.data: " + JSON.stringify(res.data));
          this.preorderCustomerdetaillist = res.data.customers;
          this.customerProducts = res.data.customerProducts;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    preorderproductalldetail() {
      this.isPreorderproductalldetail = true;
      this.isPreorderproductdetail = false;
      this.isPreordercustomerdetail = false;
      this.isProductforbuy = false;
      this.isCustomenotgetanyproduct = false;
      RestAPI.getPreorderProductAllDetail(this.selectedpreorderdateid)
        .then((res) => {
          console.log("res.data: " + JSON.stringify(res.data));
          this.preorderProductalldetaillist = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    productforbuy() {
      this.isProductforbuy = true;
      this.isPreorderproductalldetail = false;
      this.isPreorderproductdetail = false;
      this.isPreordercustomerdetail = false;
      this.isCustomenotgetanyproduct = false;
      RestAPI.getproductforbuy(this.selectedpreorderdateid)
        .then((res) => {
          console.log("res.data: " + JSON.stringify(res.data));
          this.productforbuylist = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    custtomernotgetanyproduct() {
      this.isProductforbuy = false;
      this.isPreorderproductalldetail = false;
      this.isPreorderproductdetail = false;
      this.isPreordercustomerdetail = false;
      this.isCustomenotgetanyproduct = true;
      RestAPI.getcusttomernotgetanyproduct(this.selectedpreorderdateid)
        .then((res) => {
          console.log("res.data: " + JSON.stringify(res.data));
          this.customernotgetanyproductlist = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    informCustomer(customerid) {
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການຕໍ່ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            customerid: customerid,
            preorderdateid: this.selectedpreorderdateid,
            username: this.username,
          };

          RestAPI.preorderInformCustomer(params)
            .then(() => {
              this.custtomernotgetanyproduct();
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    onFileSelected(event) {
      // console.log("url: "+ this.url)
      // console.log("photopath: " + this.photopath)
      this.selectedFile = event.target.files[0];
      const fd = new FormData();
      fd.append("image", this.selectedFile);
      axios.post(this.url, fd).then((res) => {
        this.photoname = res.data;
        this.photopreview = this.photopath + res.data;
      });
    },
    getImgUrl(photoname) {
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      // console.log("photoname: " + photoname)
      // console.log("photopreview: " + photopreview)
      return photopreview;
    },

    processPreorderToOrder() {
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການຕໍ່ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            marketid: this.marketid,
            preorderdateid: this.selectedpreorderdateid,
            senddate: this.dateFormatterYYYYMMDD(this.selectedsenddate),
            username: this.username,
          };

          console.log("params: " + JSON.stringify(params));

          RestAPI.processPreorderToOrder(params)
            .then((res) => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.selectedpreorderdatestatus = 2;
              this.getPreorderDate(this.sellectedsellerid);
              console.log("res:-" + JSON.stringify(res.data));
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    PrepareToOrder() {
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການຕໍ່ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            marketid: this.marketid,
            preorderdateid: this.selectedpreorderdateid,
            senddate: this.dateFormatterYYYYMMDD(this.selectedsenddate),
            username: this.username,
          };

          // console.log("params: " + JSON.stringify(params));

          RestAPI.PrepareToOrder(params)
            .then((res) => {
              console.log("res:" + JSON.stringify(res.data));

              if (res.data.status == "ok") {
                this.checkOrderPrepare();

                setTimeout(this.showAlert, 2000);

                setTimeout(
                  this.productsdatedetail(
                    this.selectedpreorderdateid,
                    this.selectedstartdate,
                    this.selectedenddate,
                    this.selectedsenddate,
                    this.selectedpreorderdatestatus,
                    this.sellectedsellerid
                  ),
                  2000
                );

                // this.
              } else if (res.data.status == "null_provided") {
                this.$swal(
                  "ຍັງກວດສອບ ສິນຄ້າຍ່ອຍບໍ່ຄົບທຸກລາຍການ!",
                  "",
                  "warning"
                );
              } else {
                this.$swal("ບໍ່ມີລາຍການສັ່ງຈອງ!", "", "warning");
              }

              // console.log("res:-" + JSON.stringify(res.data));
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    CancelPreorder(orderid) {
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການຕໍ່ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            orderid: orderid,
            username: this.username,
          };

          // console.log("params: " + JSON.stringify(params));

          RestAPI.CancelPreorder(params)
            .then(() => {
             
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              setTimeout(
                  this.productsdatedetail(
                    this.selectedpreorderdateid,
                    this.selectedstartdate,
                    this.selectedenddate,
                    this.selectedsenddate,
                    this.selectedpreorderdatestatus,
                    this.sellectedsellerid
                  ),
                  2000);
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    PrepareToSingleOrder(orderid, customerid) {
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການຕໍ່ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            marketid: this.marketid,
            preorderdateid: this.selectedpreorderdateid,
            orderid: orderid,
            customerid: customerid,
            senddate: this.dateFormatterYYYYMMDD(this.selectedsenddate),
            username: this.username,
          };

          // console.log("params: " + JSON.stringify(params));

          RestAPI.PrepareToSingleOrder(params)
            .then((res) => {
              console.log("res----:" + JSON.stringify(res.data));

              if (res.data.status == "ok") {
                // setTimeout(this.showAlert, 2000);

                setTimeout(
                  this.productsdatedetail(
                    this.selectedpreorderdateid,
                    this.selectedstartdate,
                    this.selectedenddate,
                    this.selectedsenddate,
                    this.selectedpreorderdatestatus,
                    this.sellectedsellerid
                  ),
                  2000
                );
              } else if (res.data.status == "null_provided") {
                this.$swal(
                  "ຍັງກວດສອບ ສິນຄ້າຍ່ອຍບໍ່ຄົບທຸກລາຍການ!!",
                  "",
                  "warning"
                );
              } else {
                this.$swal("ບໍ່ມີລາຍການສັ່ງຈອງ!", "", "warning");
              }
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    processPreorderToSingleOrder(orderid, customerid) {
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການຕໍ່ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            marketid: this.marketid,
            preorderdateid: this.selectedpreorderdateid,
            orderid: orderid,
            customerid: customerid,
            senddate: this.dateFormatterYYYYMMDD(this.selectedsenddate),
            username: this.username,
          };

          console.log("params: " + JSON.stringify(params));

          RestAPI.processPreorderToSingleOrder(params)
            .then((res) => {
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              if(res.data.isFinalOrder==1){
                this.selectedpreorderdatestatus = 2;
              }
              if (res.data.status == "ok") {
                setTimeout(
                  this.productsdatedetail(
                    this.selectedpreorderdateid,
                    this.selectedstartdate,
                    this.selectedenddate,
                    this.selectedsenddate,
                    this.selectedpreorderdatestatus,
                    this.sellectedsellerid
                  ),
                  2000
                );
              } else {
                this.$swal("Process order ບໍ່ສຳເລັດ", "", "warning");
              }
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    showAlert() {
      if (this.isOrderPrepare == true) {
        this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
      } else if (this.isOrderPrepare == false) {
        this.$swal("ກວດສອບສິນຄ້າ (Grading) ໃຫ້ຖືກຕ້ອງ", "", "warning");
      }
    },
    checkOrderPrepare() {
      RestAPI.checkOrderPrepare(this.selectedpreorderdateid)
        .then((res) => {
          console.log(
            "this.selectedpreorderdateid:" + this.selectedpreorderdateid
          );
          // console.log("res.data: " + res.data);
          this.isOrderPrepare = res.data;

          // console.log("res.data: " + JSON.stringify(res.data))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    OrderDetail() {
      this.activeSubSubTab = 2;
      this.selectedpreorderdateid;
    },
    savePreorderDate() {
       console.log("this.formdate: "+ this.formdate)
      var params = {
        preorder_startdate: this.dateFormatterYYYYMMDD(this.preorder_startdate),
        preorder_enddate: this.dateFormatterYYYYMMDD(this.preorder_enddate),
        preorder_senddate: this.dateFormatterYYYYMMDD(this.preorder_senddate),
        marketid: this.marketid,
        sellerid: this.sellerid,
        username: this.username,
      };

      console.log("params: ", JSON.stringify(params));

      RestAPI.savePreorderDate(params)
        .then(res => {
          console.log("res: " + JSON.stringify(res.data))
          if(res.data=="duplicate market preorder date"){
            this.$swal("duplicate market preorder date !", "", "warning"); 
          }else{
            this.$swal("ບັນທືກ ສຳເລັດ!", "", "success");
            this.getPreorderDate(this.sellerid);

            // this.getProducts();
            // this.getProductsMarketPreQuotaDateCount();
            // this.getMarkets();
            // this.preQuotalList();
            this.activeFormTab = 1;
          }
         
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    onSelectedProductionAction(action) {
      this.selectedAction = action ? action : this.selectedAction;
      if (action.ACTIONID == 0) {
        this.$swal("ກະລູນາເລືອກໃຫ້ຖືກຕ້ອງ", "", "error");
      } else if (
        this.actionAmount == 0 ||
        this.actionAmount === null ||
        this.actionAmount == " "
      ) {
        this.$swal("ກະລູນາປ້ອນຈຳນວນ", "", "error");
      } else if (
        (action.ACTIONID == 1 && this.farmerProductionProstatus == "2") ||
        (action.ACTIONID == 2 && this.farmerProductionProstatus == "3")
      ) {
        // console.log("this.selectedFarmer: " + JSON.stringify(this.selectedFarmer));
        console.log("actionid: " + this.actiondate);
        console.log("status: " + this.farmerProductionProstatus);
        var params = {
          productionid: this.selectedProductionid,
          actionid: action.ACTIONID,
          actiondate: this.dateFormatterYYYYMMDD(this.actionDate),
          amount: this.actionAmount,
          username: this.username,
        };
        RestAPI.productionAction(params)
          .then(() => {
            this.farmerProduction(this.selectedProductionid);

            this.$swal("ສຳເລັດ !", "", "success");
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      } else {
        this.$swal("ບໍ່ສາມາດດຳເນີນການໄດ້", "", "error");
        this.farmerProduction(this.selectedProductionid);
      }
    },
    productionReport() {
      if (
        this.productionReportDetail === null ||
        this.productionReportDetail == " "
      ) {
        this.$swal("ກະລູນາ ລະບຸບັນຫາ", "", "error");
      } else {
        // this.selectedProductionid
        console.log("productionReport: " + this.productionReportDetail);

        var params = {
          productionid: this.selectedProductionid,
          detail: this.productionReportDetail,
          // reportDate: this.dateFormatterYYYYMMDD(this.reportDate),
          username: this.username,
        };

        RestAPI.productionReport(params)
          .then(() => {
            this.farmerProduction(this.selectedProductionid);
            this.getProductionReport(this.selectedProductionid);
            this.productionReportDetail = null;
            this.$swal("ສຳເລັດ !", "", "success");
          })
          .catch((error) => {
            console.log(error);
            if (error == "Error: Request failed with status code 400") {
              this.$swal("Check Input Data", "", "error");
            } else {
              this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
            }
          });
      }
    },

    getProductionReport(productionid) {
      RestAPI.getProductionReport(productionid)
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.productionReportList = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getMarkets() {
      // console.log("market");
      RestAPI.getPreOrderMarket()
        .then((res) => {
          // console.log("list:"+ JSON.stringify(res.data))
          this.activemarkets = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getProductType() {
      RestAPI.getProductType()
        .then((res) => {
          this.productType = res.data.activeProductType;
          // console.log("prodcuttype: " + JSON.stringify(this.productType));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getProducts() {
      // console.log("senddate: " + senddate);
      RestAPI.getPreorderProducts(this.selectedpreorderdateid)
        .then((res) => {
          this.products = res.data;
          // console.log("products: " + JSON.stringify(this.products));
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getProductsMarketPreQuotaDateCount() {
      RestAPI.getProductsMarketPreQuotaDateCount(this.marketid)
        .then((res) => {
          this.prequota = res.data[0].REDATE;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    preQuotalList() {
      this.isActiveQuotaForm = false;
      RestAPI.preMarketQuotalList(this.marketid)
        .then((res) => {
          console.log("res: " + JSON.stringify(res.data));
          this.preQuotaList = res.data.wait;
          this.postQuotaList = res.data.approved;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    openQuotaForm() {
      this.isActiveQuotaForm = true;
      this.preQuotaProductList = null;
      this.postQuotaProductList = null;
    },
    openPreQuotaDetail(redate, status) {
      this.selectedRedate = redate;
      this.isPreQuotaDetail = true;
      this.waitstatus = status;
      RestAPI.preMarketQuotaProductList(this.marketid, redate)
        .then((res) => {
          this.preQuotaProductList = res.data.wait;
          this.postQuotaProductList = res.data.approved;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    gotomarketquotadetailform(ID, MARTKETNAME, SELLERID) {
      this.activeTab = 1;
      this.activeFormTab = 1;
      this.preorderproductdetaillist = null;
      this.preordercustomerdetaillist = null;
      this.marketid = ID;
      this.marketname = MARTKETNAME;
      this.sellerid = SELLERID;
      this.selectedstartdate = null;
      this.selectedenddate = null;
      this.selectedsenddate = null;
      this.getPreorderDate(SELLERID);
      // this.quotaToProduction(ID, MARTKETNAME);
      // this.marketquotadetailform(ID, MARTKETNAME);
      // this.preQuotalList();
    },
    marketquotadetailform(ID, MARTKETNAME) {
      this.marketid = ID;
      this.marketname = MARTKETNAME;
      this.getProducts();
      this.getProductsMarketPreQuotaDateCount();
      this.quotaToProduction(ID, MARTKETNAME);
      // console.log("marketid: " + this.marketid);
      // console.log("redate: " + this.dateFormatterYYYYMMDD(this.selecteddate));
    },

    updatePreOrderProductForm(data, preorderdatestatus) {
      this.activeSubSubTab = 1;
      this.updateProductname = data.PRODUCTNAME;
      this.updateProductnameSub = data.PRODUCTNAME_SUB;
      this.updateAmount = data.QUANTITY;
      this.updatePrice = data.UNITPRICE;
      this.updatePreOrderProductid = data.PREORDERPRODUCTID;
      this.photoname = data.IMAGEURL;
      this.photopreview = this.photopath + data.IMAGEURL;
      this.selectedpreorderdatestatus = preorderdatestatus;
      this.selecteQuantityOrdered = data.QUANTITYORDERED;

      // console.log("data:" + JSON.stringify(data));
      // this.activeTab = 1;
      // this.activeFormTab = 1;
      // this.marketid = ID;
      // this.marketname = MARTKETNAME;
      // this.sellerid = SELLERID;
      // this.getPreorderDate(SELLERID);
      // this.quotaToProduction(ID, MARTKETNAME);
      // this.marketquotadetailform(ID, MARTKETNAME);
      // this.preQuotalList();
    },
    updatePreOrderProduct() {
      //  console.log("this.formdate: "+ this.formdate)

      var params = {
        updatePreOrderProductid: this.updatePreOrderProductid,
        updateAmount: this.updateAmount,
        updatePrice: this.updatePrice,
        photoname: this.photoname,
        username: this.username,
      };

      console.log("params:- ", JSON.stringify(params));

      RestAPI.updatePreOrderProduct(params)
        .then(() => {
          this.$swal("ແກ້ໄຂ ສຳເລັດ!", "", "success");
          this.activeSubSubTab = 0;
          // console.log("this.selectedsenddate: " + this.selectedsenddate)
          this.productsdatedetail(
            this.selectedpreorderdateid,
            this.selectedstartdate,
            this.selectedenddate,
            this.selectedsenddate,
            this.selectedpreorderdatestatus,
            this.sellectedsellerid
          );
          // this.getProducts(this.senddate);
          // this.getProductsMarketPreQuotaDateCount();
          // this.getMarkets();
          // this.preQuotalList();
          this.photoname = null;
          this.updateAmount = null;
          this.updatePrice = null;
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    gotomarketlist() {
      this.activeTab = 0;
      this.activeSubTab = 0;
      this.activeQuotaSubTab = 0;
    },
    gotoquotaToProduction(ID, MARTKETNAME) {
      this.activeTab = 2;
      this.activeQuotaSubTab = 0;
      this.quotaToProduction(ID, MARTKETNAME);
      this.marketquotadetailform(ID, MARTKETNAME);
      this.getFarmerList();
    },
    quotaToProduction(ID, MARTKETNAME) {
      this.marketid = ID;
      this.marketname = MARTKETNAME;

      RestAPI.getProductToProduction(this.marketid)
        .then((res) => {
          this.quotaltoproduction = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    gotoquotadate() {
      this.activeQuotaSubTab = 0;
    },

    getPreorderDate(sellerid) {
      RestAPI.getPreorderDate(sellerid) // ແລ້ວອັບເດດເປັນ branchid ແລະ ໄປຊອກໃນ ຶ branchprovinces
        .then((res) => {
          this.preorderdatelist = res.data;
          // console.log("preorderdatelist: " + JSON.stringify(this.preorderdatelist))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getFarmerList() {
      // console.log("ok: " , this.userProvinceID)
      RestAPI.getFarmerList(this.userProvinceID) // ແລ້ວອັບເດດເປັນ branchid ແລະ ໄປຊອກໃນ ຶ branchprovinces
        .then((res) => {
          this.farmerList = res.data;
          // console.log("farmerlist: " + JSON.stringify(this.farmerList))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    getFarmerProductionList() {
      // console.log("ok: " , this.userProvinceID)
      RestAPI.getFarmerProductionList(this.userProvinceID, this.quotadate)
        .then((res) => {
          this.farmerProductionList = res.data;
          console.log(
            "farmerProductionList: " + JSON.stringify(this.farmerProductionList)
          );
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    onSelectedFarmer(data) {
      //console.log("data-: " + JSON.stringify(data));
      if (
        data.REMAINAMOUNTFORUSE === null ||
        data.REMAINAMOUNTFORUSE == 0 ||
        !data.REMAINAMOUNTFORUSE
      ) {
        this.$swal("ກະລູນາປ້ອນຈຳນວນ", "", "error");
      } else if (data.REMAINAMOUNTFORUSE > data.REMAINAMOUNT) {
        this.$swal("ຈຳນວນທີ່ປ້ອນ ເກີນຈຳນວນຍັງເຫຼ່ືອ", "", "error");
      } else {
        this.$swal({
          title: "ຕ້ອງການຈັດແຜນໃຫ້ຊາວກະສິກອນ ແທ້ບໍ່?",
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: "ຕ້ອງການ",
          cancelButtonText: "ບໍ່ຕ້ອງການ",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
        }).then((result) => {
          if (result.value) {
            var params = {
              requirementid: data.ID,
              amount: data.REMAINAMOUNTFORUSE,
              productid: data.PRODUCTID,
              farmerid: data.selectedFarmer.FARMERID,
              farmid: data.selectedFarmer.FARMID,
              username: this.username,
            };
            console.log("params: ", JSON.stringify(params));
            RestAPI.setMarketPlanForFarmer(params)
              .then((res) => {
                this.$swal("ຈັດແຜນໃຫ້ຊາວກະສິກອນ ສຳເລັດ!", "", "success");
                console.log("res: ", JSON.stringify(res.data));
                this.quotadatededtailtab(data.REDATE);
                // this.getDppContractProductList(this.activePlanYear);
              })
              .catch((error) => {
                console.log(error);
                if (error == "Error: Request failed with status code 400") {
                  this.$swal("Check Input Data", "", "error");
                } else {
                  this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
                }
              });
          }
        });
      }
    },

    actionToMarketPlanForFarmer(data, status) {
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການແທ້ບໍ່ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            requirementid: data.ID,
            status: status,
            username: this.username,
          };
          RestAPI.actionToMarketPlanForFarmer(params)
            .then(() => {
              console.log("pararm: " + params);
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              this.quotadatededtailtab(data.REDATE);
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    farmerProduction(productionid) {
      RestAPI.getfarmerProduction(productionid)
        .then((res) => {
          this.getProductionReport(productionid);
          // console.log("farmerProduction:"+ JSON.stringify(res.data))
          // this.activemarkets = res.data.activemarkets;
          // this.inactivemarkets = res.data.inactivemarkets;
          this.selectedProductionid = productionid;
          // console.log("data: " + JSON.stringify(farmer))
          // console.log("dateproduction: " + JSON.stringify(dateproduction))
          this.farmerProductionFarmername = res.data[0].FARMERNAME;
          this.farmerProductionRequestID = res.data[0].MARKETREQUESTID;
          this.farmerProductionID = res.data[0].PROID;
          this.farmerProductionRedate = res.data[0].REDATE;
          this.farmerProductionGetplandate = res.data[0].GETPLANDATE;
          this.farmerProductionFarmID = res.data[0].FARMID;
          this.farmerProductionFarmerID = res.data[0].FARMERID;
          this.farmerProductionTotalAmount = res.data[0].TOTALAMOUNT;
          this.farmerProductionProductid = res.data[0].PRODUCTID;
          this.farmerProductionProductname = res.data[0].PRODUCTNAME;
          this.farmerProductionUnit = res.data[0].UNIT;
          this.farmerProductionAmount = res.data[0].AMOUNT;
          this.farmerProductionRecommentdate = res.data[0].RECOMMENTPRODUCEDATE;
          this.farmerProductionProdate = res.data[0].PRODUCEDATE;
          this.farmerProductionProamount = res.data[0].PRODUCEAMOUNT;
          this.farmerProductionHarvestdate = res.data[0].HARVESTDATE;
          this.farmerProductionHarvestamount = res.data[0].HARVESTAMOUNT;
          this.farmerProductionProstatus = res.data[0].PROSTATUS;

          this.activeQuotaSubTab = 3;
          this.isFarmerProduction = true;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    // onSelecteddate() {
    //   this.getProducts();
    //   // this.formdate = this.dateFormatterYYYYMMDD(this.selecteddate);
    //   // console.log(this.formdate);
    // },

    saveProducttoDateForm(
      preorderdateid,
      startdate,
      enddate,
      senddate,
      status,
      sellerid
    ) {
      this.activeFormTab = 2;
      this.selectedpreorderdate = senddate;
      this.selectedstartdate = startdate;
      this.selectedenddate = enddate;
      this.selectedsenddate = senddate;
      this.selectedpreorderdateid = preorderdateid;
      this.selectedpreorderdatestatus = status;
      this.sellectedsellerid = sellerid;

      this.getProducts();
    },

    productsdatedetail(
      preorderdateid,
      startdate,
      enddate,
      senddate,
      status,
      sellerid
    ) {
      this.activeFormTab = 3;
      this.activeSubSubTab = 0;
      this.preorderCustomerdetaillist = null;
      this.preorderProductdetaillist = null;
      this.preorderProductalldetaillist = null;
      this.resetUpdateform();
      this.selectedstartdate = startdate;
      this.selectedenddate = enddate;
      this.selectedsenddate = senddate ? senddate : this.selectedsenddate;
      this.selectedpreorderdateid = preorderdateid;
      this.selectedpreorderdatestatus = status;
      this.sellectedsellerid = sellerid;
      // this.checkOrderPrepare();
      this.getProducts();

      RestAPI.getProductsDateDetail(this.selectedpreorderdateid)
        .then((res) => {
          this.productsdatelist = [];
          this.productforbuylist = [];
          this.productsdatelist = res.data;
          this.preordercustomerdetail();
          // console.log(
          //   "getProductsDateDetail: " + JSON.stringify(this.productsdatelist)
          // );
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });

      // this.selectedpreorderdate = senddate;
      // this.selectedstartdate = startdate;
      // this.selectedenddate = enddate;
      // this.selectedsenddate = senddate;
    },

    reloadAfterProvidedProduct() {
      RestAPI.getProductsDateDetail(this.selectedpreorderdateid)
        .then((res) => {
          this.productsdatelist = [];
          this.productforbuylist = [];
          this.productsdatelist = res.data;
          // this.preordercustomerdetail();

        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getPreORderDetail(preorderid, productsubid) {
      RestAPI.getPreORderDetail(preorderid, productsubid)
        .then((res) => {
          this.preorderdetail = res.data;
          // console.log(
          //   "getProductsDateDetail: " + JSON.stringify(this.productsdatelist)
          // );
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    resetUpdateform() {
      this.updateProductname = null;
      this.updateProductnameSub = null;
      this.updateAmount = 0;
      this.updatePrice = 0;
    },

    onSelectedquotaldate() {
      this.quotadatededtailtab(
        this.dateFormatterYYYYMMDD(this.selectedquotaddate)
      );
      console.log(
        "this.dateFormatterYYYYMMDD(this.selectedquotaddate): " +
          this.dateFormatterYYYYMMDD(this.selectedquotaddate)
      );
    },
    saveProductAmount() {
      //  console.log("this.formdate: "+ this.formdate)

      var params = {
        preorderdateid: this.selectedpreorderdateid,
        startdate: this.dateFormatterYYYYMMDD(this.selectedstartdate),
        enddate: this.dateFormatterYYYYMMDD(this.selectedenddate),
        senddate: this.dateFormatterYYYYMMDD(this.selectedsenddate),
        sellerid: this.sellerid,
        marketid: this.marketid,
        products: this.products,
        username: this.username,
      };

      console.log("params:- ", JSON.stringify(params));

      RestAPI.savePreOrderProductAmount(params)
        .then(() => {
          // this.$swal("ບັນທືກ ສຳເລັດ!", "", "success");
          this.getProducts();
          // this.getProductsMarketPreQuotaDateCount();
          // this.getMarkets();
          // this.preQuotalList();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    saveGotProductAmount() {
      //  console.log("this.formdate: "+ this.formdate)

      var params = {
        preorderdateid: this.selectedpreorderdateid,
        products: this.productforbuylist,
        username: this.username,
      };

      console.log("params:- ", JSON.stringify(params));

      RestAPI.saveGotPreOrderProductAmount(params)
        .then(() => {
          this.productforbuy();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    clearGotProductAmount() {
      //  console.log("this.formdate: "+ this.formdate)
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການຕໍ່ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            preorderdateid: this.selectedpreorderdateid,
            username: this.username,
          };

          RestAPI.clearGotPreOrderProductAmount(params)
            .then(() => {
              this.productforbuy();
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },

    settletoProductGrading() {
      //  console.log("this.formdate: "+ this.formdate)
      this.$swal({
        title: "ຕ້ອງການດຳເນີນການຕໍ່ ແທ້ບໍ່?",
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonText: "ຕ້ອງການ",
        cancelButtonText: "ບໍ່ຕ້ອງການ",
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
      }).then((result) => {
        if (result.value) {
          var params = {
            preorderdateid: this.selectedpreorderdateid,
            marketid: this.marketid,
            sellerid: this.sellectedsellerid,
            username: this.username,
          };

          RestAPI.settletoProductGrading(params)
            .then(() => {
              this.productforbuy();
              this.$swal("ດຳເນີນການ ສຳເລັດ!", "", "success");
              // call function check status from m_preorder_got
            })
            .catch((error) => {
              console.log(error);
              if (error == "Error: Request failed with status code 400") {
                this.$swal("Check Input Data", "", "error");
              } else {
                this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
              }
            });
        }
      });
    },
    unSetAllProducts() {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selectedRedate),
        marketid: this.marketid,
        username: this.username,
      };

      RestAPI.unSetAllProducts(params)
        .then(() => {
          this.$swal("ລ້າງໂຄຕ້າ ສຳເລັດ!", "", "success");
          this.preQuotalList();
          this.openPreQuotaDetail(this.selectedRedate);
          this.getProducts();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    unSetProductsAmount(type) {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selectedRedate),
        marketid: this.marketid,
        typeid: type,
        username: this.username,
      };

      RestAPI.unSetProductsAmount(params)
        .then(() => {
          this.$swal("ລ້າງໂຄຕ້າ ສຳເລັດ!", "", "success");
          this.getProducts();
          // this.preQuotalList()
          // this.openPreQuotaDetail(this.selectedRedate)
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    unSetProductAmount(productid) {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        redate: this.dateFormatterYYYYMMDD(this.selectedRedate),
        marketid: this.marketid,
        productid: productid,
        username: this.username,
      };
      console.log("params: " + JSON.stringify(params));

      RestAPI.unSetProductAmount(params)
        .then(() => {
          this.$swal("ລ້າງໂຄຕ້າ ສຳເລັດ!", "", "success");
          this.preQuotalList();
          this.openPreQuotaDetail(this.selectedRedate);
          // this.getProducts();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    setAllProductsToProduction() {
      var params = {
        marketid: this.marketid,
        redate: this.dateFormatterYYYYMMDD(this.selectedRedate),
        username: this.username,
      };

      console.log("par: " + JSON.stringify(params));

      RestAPI.setAllProductsToProduction(params)
        .then(() => {
          this.$swal("ສົ່ງຜະລິດ ສຳເລັດ!", "", "success");
          this.preQuotalList();
          this.openPreQuotaDetail(this.selectedRedate);
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    setProductsToProduction(typeid) {
      var params = {
        typeid: typeid,
        redate: this.dateFormatterYYYYMMDD(this.selecteddate),
        username: this.username,
      };

      console.log("par: " + JSON.stringify(params));

      RestAPI.setProductsToProduction(params)
        .then(() => {
          this.$swal("ສົ່ງຜະລິດ ສຳເລັດ!", "", "success");
          this.getProducts();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },

    setProductToProduction(mrid) {
      //  console.log("this.formdate: "+ this.formdate)
      var params = {
        mrid: mrid,
        username: this.username,
      };

      RestAPI.setProductToProduction(params)
        .then(() => {
          this.$swal("ສົ່ງຜະລິດ ສຳເລັດ!", "", "success");
          this.getProducts();
        })
        .catch((error) => {
          console.log(error);
          if (error == "Error: Request failed with status code 400") {
            this.$swal("Check Input Data", "", "error");
          } else {
            this.$swal("ມີຂໍ້ຜິດພາດ: " + error, "-", "error");
          }
        });
    },
    quotadatededtailtab(redate) {
      console.log("redate: " + redate);
      this.quotadate = redate;
      this.activeQuotaSubTab = 1;
      RestAPI.getquotadatededtail(this.marketid, this.quotadate)
        .then((res) => {
          this.quotadatetypes = res.data.quotadatetypes;
          this.quotadateproducts = res.data.quotadateproducts;
          console.log(
            "quotadateproducts: " + JSON.stringify(this.quotadateproducts[0])
          );
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },

    productiondatededtailtab(redate) {
      console.log("redate: " + redate);
      this.quotadate = redate;
      this.activeQuotaSubTab = 2;
      RestAPI.getquotadatededtail(this.marketid, this.quotadate)
        .then((res) => {
          this.quotadatetypes = res.data.quotadatetypes;
          this.dateproductions = res.data.dateproductions;
          this.getFarmerProductionList();
          // console.log("quotadateproducts: "+ JSON.stringify(this.quotadateproducts[0]))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    preorderSearch() {
      if (this.search) {
        var params = {
          preorderdateid: this.selectedpreorderdateid,
          search: this.search,
        };
        RestAPI.preorderSearch(params)
          .then((res) => {
            this.products = res.data;
            // console.log("products: " + JSON.stringify(this.products));
          })
          .catch((error) => {
            console.log(error);
            this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
          });
      } else {
        this.getProducts();
      }
    },

    mynumberformat(number) {
      console.log("number: " + number);
      var n = String(number)
        .split("")
        .map(Number);
      console.log("n.length: " + n.length);
      if (n.length == 10) {
        return (
          n[0] +
          "" +
          n[2] +
          "," +
          n[3] +
          "" +
          n[4] +
          "" +
          n[6] +
          "," +
          n[7] +
          "" +
          n[8] +
          "" +
          n[9]
        );
      } else if (n.length == 8) {
        return (
          n[0] +
          "," +
          n[1] +
          "" +
          n[2] +
          "" +
          n[4] +
          "," +
          n[5] +
          "" +
          n[6] +
          "" +
          n[7]
        );
      } else if (n.length == 7) {
        return (
          n[0] + "" + n[1] + "" + n[3] + "," + n[4] + "" + n[5] + "" + n[6]
        );
      } else if (n.length == 6) {
        return n[0] + "" + n[2] + "," + n[3] + "" + n[4] + "" + n[5];
      } else if (n.length == 4) {
        return n[0] + "," + n[1] + "" + n[2] + "" + n[3];
      } else {
        return number;
      }
    },

    numberFormat(index, value) {
      this.products[index].PRICE = this.mynumberformat(value);
      console.log("PRICE: " + JSON.stringify(this.products[index]));
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },

    print() {
      window.print();
    },
  },
  mounted() {
    // console.log("this.user.BRANCHPROVNICEID: " + JSON.stringify(this.user));
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.userProvinceID = this.user.BRANCHPROVNICEID
      ? this.user.BRANCHPROVNICEID
      : "all";
    // this.getFarmerList();
    this.getMarkets();
    this.getProductType();

    this.selecteddate = new Date();
    this.actionDate = new Date();
    this.reportDate = new Date();
    this.selectedquotaddate = new Date();
    this.formdate = new Date();
    this.todate = this.dateFormatterYYYYMMDD(new Date());
  },
  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },
    filteredResources() {
      if (this.search) {
        return this.products
          .filter((product) => {
            return product.PRODUCTNAME.includes(this.search);
          })
          .sort((a, b) => {
            return b.MRAMOUNT - a.MRAMOUNT;
          });
      } else {
        return this.products.sort((a, b) => {
          return b.MRAMOUNT - a.MRAMOUNT;
        });
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.borderless td,
.borderless th {
  border: none;
}
</style>
